import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LifeBuoy, Search } from "lucide-react";
import RecoveryOptions from "../components/travel/RecoveryOptions";

/* Flight Recovery Assistant — PUBLIC page (no login). Differentiator: TripIt locks
   disruption help behind Pro; TravelerPulse gives it to every traveler for free.
   Deep-linkable: /recovery?origin=SEA&dest=DXB&airline=EK&date=YYYY-MM-DD (used by alerts). */
export default function FlightRecovery() {
  const [params] = useSearchParams();
  const [f, setF] = useState({
    origin: (params.get("origin") || "").toUpperCase().slice(0, 3),
    dest: (params.get("dest") || "").toUpperCase().slice(0, 3),
    airline: (params.get("airline") || "").toUpperCase().slice(0, 3),
    date: params.get("date") || "",
  });
  const [query, setQuery] = useState(null);
  useEffect(() => { // auto-search when arriving from an alert deep-link
    if (f.origin.length === 3 && f.dest.length === 3) setQuery({ ...f });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value.toUpperCase().slice(0, k === "date" ? 10 : 3) }));
  const ready = f.origin.length === 3 && f.dest.length === 3;
  const inp = "w-full border border-zinc-300 bg-white px-3 py-2.5 text-sm font-mono uppercase focus:outline-none focus:border-rose-600";
  const lbl = "block text-xs font-mono uppercase tracking-widest text-muted-foreground mb-1";
  return (
    <div className="min-h-screen bg-zinc-50">
      <div className="bg-[#4285F4] text-white">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-12">
          <h1 className="font-heading font-900 text-4xl sm:text-5xl flex items-center gap-3">
            <LifeBuoy className="w-10 h-10 text-[#FBBC05]" /> Flight Recovery Assistant
          </h1>
          <p className="text-blue-50 mt-3 max-w-2xl text-base md:text-lg">
            Flight delayed or cancelled? See which other airlines fly your route, check live same-day
            options, and know exactly what you're owed — free, no account needed.
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-5 lg:px-8 py-10">
        <div className="bg-white border border-zinc-300 p-5 mb-8" data-testid="recovery-form">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <div><label className={lbl}>From (IATA)</label>
              <input value={f.origin} onChange={set("origin")} placeholder="SEA" className={inp} data-testid="recovery-origin" /></div>
            <div><label className={lbl}>To (IATA)</label>
              <input value={f.dest} onChange={set("dest")} placeholder="DXB" className={inp} data-testid="recovery-dest" /></div>
            <div><label className={lbl}>Airline (optional)</label>
              <input value={f.airline} onChange={set("airline")} placeholder="EK" className={inp} data-testid="recovery-airline" /></div>
            <div><label className={lbl}>Date (optional)</label>
              <input type="date" value={f.date} onChange={(e) => setF((p) => ({ ...p, date: e.target.value }))} className={inp} data-testid="recovery-date" /></div>
          </div>
          <button onClick={() => setQuery({ ...f })} disabled={!ready} data-testid="recovery-search"
            className="mt-4 inline-flex items-center gap-1.5 px-5 py-2.5 bg-rose-700 text-white text-sm font-700 hover:bg-rose-600 disabled:opacity-40">
            <Search className="w-4 h-4" /> Show my options
          </button>
        </div>
        {query && <RecoveryOptions origin={query.origin} dest={query.dest} airline={query.airline} date={query.date} />}
      </div>
    </div>
  );
}
